<template>
  <div style="position:relative;">
    <div class="checkstand-defined" v-show="showCheckstand">
      <div class="van-overlay" style="z-index: 1995"></div>
      <div class="van-popup van-popup--round van-popup--bottom" style="z-index: 1996; transation: 0.8s"
        :class="{ hide: !showCheckstand, checkstandStyle: checkstandStyle }">
        <div class="order-info">
          <p>支付金额</p>
          <!-- <p class="order-price" v-if="dataToPay.toatl">
            ￥{{ money_format(price, 2, ".", ",") - dataToPay.toatl > 0 ? money_format(money_format(price, 2, ".", ",") -
              dataToPay.toatl) : 0 }}
          </p> -->
          <p class="order-price">
            ￥{{ money_format(price, 2, ".", ",") }}
          </p>
        </div>

        <!-- 总部微信公众号 -->
        <div class="payTypeList">
          <van-divider :style="{ color: '#828282' }" />

          <!-- 乐刷支付 -->
          <div v-if="showPayChannel('lsCollectConfig')" class="payTypeList-item" @click="flowRechargeByLS(dataToPay)">
            <div class="payTypeList-item-img">
              <img src="@/assets/wechat.jpg" />
            </div>
            <div class="payTypeList-item-name">微信支付</div>
            <div class="payTypeList-item-icon">
              <div>
                <van-icon name="arrow" color="#828282" size="20" />
              </div>
            </div>
          </div>
          <van-divider v-if="showPayChannel('lsCollectConfig')" :style="{ color: '#828282' }" />
          <!-- 乐刷支付 end -->

          <!-- 汇天下 -->
          <div v-if="showPayChannel('hfCollectConfig')" class="payTypeList-item" @click="flowRechargeByAdaPay(dataToPay)">
            <div class="payTypeList-item-img">
              <img src="@/assets/wechat.jpg" />
            </div>
            <div class="payTypeList-item-name">微信支付</div>
            <div class="payTypeList-item-icon">
              <div>
                <van-icon name="arrow" color="#828282" size="20" />
              </div>
            </div>
          </div>
          <van-divider v-if="showPayChannel('hfCollectConfig')" :style="{ color: '#828282' }" />
          <!-- 汇天下 end -->

          <!-- 京东支付 -->
          <div v-if="showPayChannel('jdCollectConfig')" class="payTypeList-item" @click="flowRechargeByJD(dataToPay)">
            <div class="payTypeList-item-img">
              <img src="@/assets/jingdong.jpeg" />
            </div>
            <div class="payTypeList-item-name">
              <div class="jd-item">
                <p>京东支付</p>
                <p style="color: #ef2d2d; font-size: 12px">每单随机立减</p>
              </div>
            </div>
            <div class="payTypeList-item-icon">
              <div>
                <van-icon name="arrow" color="#828282" size="20" />
              </div>
            </div>
          </div>
          <van-divider v-if="showPayChannel('jdCollectConfig')" :style="{ color: '#828282' }" />
          <!-- 京东支付 end -->

          <!-- 微信支付 -->
          <div v-if="showPayChannel('wxCollectConfig')" class="payTypeList-item" @click="flowRechargeByWX(dataToPay)">
            <div class="payTypeList-item-img">
              <img src="@/assets/wechat.jpg" />
            </div>
            <div class="payTypeList-item-name">微信支付</div>
            <div class="payTypeList-item-icon">
              <div>
                <van-icon name="arrow" color="#828282" size="20" />
              </div>
            </div>
          </div>
          <van-divider v-if="showPayChannel('wxCollectConfig')" :style="{ color: '#828282' }" />
          <!-- 微信支付 end -->

          <!-- 瑞生意支付 -->
          <div v-if="showPayChannel('ruiCollectConfig')" class="payTypeList-item" @click="flowRechargeByRui(dataToPay)">
            <div class="payTypeList-item-img">
              <img src="@/assets/wechat.jpg" />
            </div>
            <div class="payTypeList-item-name">微信支付</div>
            <div class="payTypeList-item-icon">
              <div>
                <van-icon name="arrow" color="#828282" size="20" />
              </div>
            </div>
          </div>
          <van-divider v-if="showPayChannel('ruiCollectConfig')" :style="{ color: '#828282' }" />
          <!-- 瑞生意支付 end -->



          <!-- 支付宝支付 -->
          <div v-if="showPayChannel('aliCollectConfig')" class="payTypeList-item" @click="flowRechargeByAli(dataToPay)">
            <div class="payTypeList-item-img">
              <img src="@/assets/ali.png" />
            </div>
            <div class="payTypeList-item-name">支付宝支付</div>
            <div class="payTypeList-item-icon">
              <div>
                <van-icon name="arrow" color="#828282" size="20" />
              </div>
            </div>
          </div>
          <van-divider v-if="showPayChannel('aliCollectConfig')" :style="{ color: '#828282' }" />
          <!-- 支付宝支付 end -->

          <!-- 余额支付  -->
          <div class="payTypeList-item" v-if="showPayChannel('yeCollectConfig') && showCheckstandSource == 'flowRecharge'"
            @click="doRechargeByBalance(dataToPay, type, packageTypeCode)">
            <div class="payTypeList-item-img">
              <img src="@/assets/balance.png" />
            </div>
            <div class="payTypeList-item-name">余额支付</div>
            <div class="payTypeList-item-icon">
              <div>
                <van-icon name="arrow" color="#828282" size="20" />
              </div>
            </div>
          </div>
          <van-divider v-if="showPayChannel('yeCollectConfig') && showCheckstandSource == 'flowRecharge'"
            :style="{ color: '#828282' }" />
          <!-- 余额支付 end -->
        </div>

        <div class="cancelPay">
          <van-button round size="small" style="border-color: #f99595" @click="cancelPay">
            <span style="color: #f99595">取消支付</span>
          </van-button>
        </div>
      </div>

      <!-- 密码框 -->
      <div class="van-overlay" style="z-index: 1999" v-show="showPasswordPanel"></div>
      <div class="van-popup van-popup--round van-popup--center passwordPanel"
        style="z-index: 2000; min-height: 35%; min-width: 80%" v-show="showPasswordPanel"
        :style="{ top: PasswordPanelTop + '%' }">
        <div class="cancelInput">
          <van-icon name="cross" @click="cancelInputPassword()" />
        </div>
        <p>请输入支付密码</p>
        <h1>
          <span style="">￥</span>
          {{ money_format(price, 2, ".", ",") }}
          <!-- {{
            money_format(price, 2, ".", ",") - dataToPay.toatl > 0
            ? money_format(money_format(price, 2, ".", ",") - dataToPay.toatl)
            : 0
          }} -->
        </h1>

        <!-- 密码输入框 -->
        <van-password-input :value="yuePayParam.payPass" :focused="showKeyboard" @focus="onfocus()" />
      </div>

      <van-overlay :show="overlay" z-index="2020">
        <div class="wrapper">
          <van-loading type="spinner" color="#fff" />
        </div>
      </van-overlay>
      <!-- 密码框  end -->

      <!-- 数字键盘 -->

      <van-number-keyboard id="keyboardDefined" :z-index="2015" :show="showKeyboard" @input="onInput" @delete="onDelete"
        @blur="showKeyboard = false" />

      <div id="jdPayFormDiv"></div>

      <div v-html="payUrl"></div>
    </div>
    <div class="shareit" v-if="is_WeChat">
      <img class="arrow" src="@/assets/img/arrowhead.png" />
      <div class="follow">支付宝支付请使用游览器进行支付,<br />请在菜单中选择游览器打开<br />如已完成支付，退出重新登录查询即可</div>
    </div>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import { wxRequest } from "@/api/user.js";
// import {AdaPay} from '@/utils/adaPay.min.js'
export default {
  name: "Checkstand",
  props: [
    "checkstandStyle",
    "dataToPay",
    "price",
    "typeStyle",
    "type",
    "packageTypeCode",
  ],
  data() {
    return {
      //支付方式
      payTypeList: [],
      yucun: localStorage.getItem("yucun"),
      is_WeChat: false,
      payData: {
        soldPackageId: null,
        iccid: null,
        isAdmin: 0,
        isNextMonth: 0,
        amount: 0,
        giftBalance: 0,
        payType: null,
        mobile: localStorage.getItem("mobile"),
        source: localStorage.getItem("appid"),
        payPass: null,
        appid: localStorage.getItem("appid"),
      },
      payUrl: '',

      yuePayParam: {
        orderNo: "",
        payPass: "",
        iccid: localStorage.getItem("iccid"),
        mobile: localStorage.getItem("mobile"),
      },

      //密码输入
      showPasswordPanel: false,
      showKeyboard: false,
      overlay: false,
      PasswordPanelTop: 50,
      showKeyboardZIndex: 2015,
    };
  },

  methods: {
    onfocus() {
      this.showKeyboard = true;
      this.PasswordPanelTop = 30;
    },

    onDelete() {
      this.yuePayParam.payPass = this.yuePayParam.payPass.slice(
        0,
        this.yuePayParam.payPass.length - 1
      );
    },

    onInput(key) {
      this.yuePayParam.payPass = (this.yuePayParam.payPass + key).slice(0, 6);
      if (this.yuePayParam.payPass.length >= 6) {
        this.PasswordPanelTop = 50;

        this.yuePayParam.payPass = this.yuePayParam.payPass.slice(0, 6);
        this.overlay = true;
        wxRequest("order/sysUser/wx/ye/pkg", this.yuePayParam, "post").then(
          (res) => {
            if (res.data.code == 200) {
              Toast.success(res.data.message);
              this.cancelPay();
              this.yuePayParam.payPass = "";
              this.overlay = false;
              let self = this;
              setTimeout(function () {
                this.toHome();
              }, 1000);
            } else {
              this.overlay = false;
              Dialog.alert({ title: "提示", message: res.data.message })
                .then((action) => {
                  this.yuePayParam.payPass = "";
                })
                .catch(() => { });
            }
          }
        );
      }
    },

    /**  阿里支付宝支付 **/
    flowRechargeByAli(data) {
      console.log(this.$route)
      // 流量套餐充值
      if (this.showCheckstandSource == "flowRecharge") {
        // this.price = data.salePriceRmb;
        for (let key in data) {
          this.payData[key] = data[key];
        }
        let d = this.payData;
        this.cancelPay();

        let formData = new FormData();
        Object.keys(d).forEach((key) => {
          formData.append(key, d[key]);
        });
        wxRequest("order/ali/pkgOrder/add", formData, "post").then((res) => {
          console.log(this.$route)
          if (res.data.code == 200) {
            window.location.href = res.data.data;
            // var ua = window.navigator.userAgent.toLowerCase();
            // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            //   //     //进入引导页
            //   this.is_WeChat = true
            //   var timer = setInterval(() => {
            //     clearInterval(timer)
            //     this.$router.push({ path: this.$route.path, query: { row: encodeURIComponent(JSON.stringify(res.data.data)) } });
            //   }, 1000)
            // } else {
            //   this.payUrl = res.data.data
            //   this.$nextTick(() => {
            //     document.forms[0].submit()
            //   })
            // }
          } else if (res.data.code == 888) {
            Dialog.confirm({
              title: "购买成功",
              message: "购买成功！实名后方能正常使用（已实名请忽略）",
            }).then((action) => {
              if (action == "confirm") {
                this.toHome();

              }
            }).catch(() => {

            });
          } else {
            this.$messagebox.alert(res.data.message);
            this.cancelPay();
          }
        });

        // 余额套餐充值
      } else if (this.showCheckstandSource == "balanceRecharge") {
        this.doBalanceRecharge(80, data);
      }
    },




    /**  京东支付 **/
    flowRechargeByJD(data) {
      // 流量套餐充值
      if (this.showCheckstandSource == "flowRecharge") {
        // this.price = data.salePriceRmb;
        for (let key in data) {
          this.payData[key] = data[key];
        }
        let d = this.payData;
        this.cancelPay();

        let formData = new FormData();
        Object.keys(d).forEach((key) => {
          formData.append(key, d[key]);
        });
        wxRequest("order/jdPkgOrder/add", formData, "post").then((res) => {
          if (res.data.code == 200) {
            let div = document.createElement("div");
            div.innerHTML = res.data.data;

            let jdPayFormDiv = document.getElementById("jdPayFormDiv");
            jdPayFormDiv.appendChild(div);
            let form = document.getElementById("batchForm");

            console.log(form);
            form.submit();

            let childs = jdPayFormDiv.childNodes;
            for (let i = childs.length - 1; i >= 0; i--) {
              jdPayFormDiv.removeChild(childs[i]);
            }
          } else if (res.data.code == 888) {
            Dialog.confirm({
              title: "购买成功",
              message: "购买成功！实名后方能正常使用（已实名请忽略）",
            })
              .then((action) => {
                if (action == "confirm") {
                  this.toHome();
                }
              })
              .catch(() => {

              });
          } else {
            this.$messagebox.alert(res.data.message);
            this.cancelPay();
          }
        });

        // 余额套餐充值
      } else if (this.showCheckstandSource == "balanceRecharge") {
        this.doBalanceRecharge(30, data);
      }
    },

    /**  微信支付 **/
    flowRechargeByWX(data) {
      // 流量套餐充值
      if (this.showCheckstandSource == "flowRecharge") {
        this.cancelPay();
        for (let key in data) {
          this.payData[key] = data[key];
        }
        let d = this.payData;
        let formData = new FormData();
        Object.keys(d).forEach((key) => {
          formData.append(key, d[key]);
        });
        wxRequest("order/pkgOrder/add", formData, "post").then((res) => {
          if (res.data.code == 200) {
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              let param = res.data.data.param;
              this.onBridgeReady(param);
            }
          } else if (res.data.code == 888) {
            Dialog.confirm({
              title: "购买成功",
              message: "购买成功！实名后方能正常使用（已实名请忽略）",
            })
              .then((action) => {
                if (action == "confirm") {
                  this.toHome();
                }
              })
              .catch(() => {

              });
          } else {
            Dialog.alert({ title: "提示", message: res.data.message });
            this.cancelPay();
          }
        });

        // 余额套餐充值
      } else if (this.showCheckstandSource == "balanceRecharge") {
        let d = data;
        d.appid = localStorage.getItem("appid");
        this.doBalanceRecharge(20, d);
      }
    },


    /**  瑞生意支付 **/
    flowRechargeByRui(data) {
      // 流量套餐充值
      if (this.showCheckstandSource == "flowRecharge") {
        this.cancelPay();
        for (let key in data) {
          this.payData[key] = data[key];
        }
        let d = this.payData;
        let formData = new FormData();
        Object.keys(d).forEach((key) => {
          formData.append(key, d[key]);
        });
        wxRequest("order/ruiPkgOrder/add/pkg", formData, "post").then((res) => {
          if (res.data.code == 200) {
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              let param = res.data.data;
              this.onBridgeReady(param);
            }
          } else if (res.data.code == 888) {
            Dialog.confirm({
              title: "购买成功",
              message: "购买成功！实名后方能正常使用（已实名请忽略）",
            })
              .then((action) => {
                if (action == "confirm") {
                  this.toHome();
                }
              })
              .catch(() => {

              });
          } else {
            Dialog.alert({ title: "提示", message: res.data.message });
            this.cancelPay();
          }
        });

        // 余额套餐充值
      } else if (this.showCheckstandSource == "balanceRecharge") {
        let d = data;
        d.appid = localStorage.getItem("appid");
        this.doBalanceRecharge(32, d);
      }
    },

    /**  乐刷支付  **/
    flowRechargeByLS(data) {
      // 流量套餐充值
      if (this.showCheckstandSource == "flowRecharge") {
        this.cancelPay();
        for (let key in data) {
          this.payData[key] = data[key];
        }
        let d = this.payData;
        let formData = new FormData();
        Object.keys(d).forEach((key) => {
          formData.append(key, d[key]);
        });

        wxRequest("order/lsPkgOrder/add", formData, "post").then((res) => {
          if (res.data.code == 200) {
            window.location.href = res.data.data.jspay_url;
          } else if (res.data.code == 888) {
            Dialog.confirm({
              title: "购买成功",
              message: "购买成功！实名后方能正常使用（已实名请忽略）",
            })
              .then((action) => {
                if (action == "confirm") {
                  this.toHome();
                }
              })
              .catch(() => {

              });
          } else {
            Dialog.alert({ title: "提示", message: res.data.message });
            this.cancelPay();
          }
        });

        // 余额套餐充值
      } else if (this.showCheckstandSource == "balanceRecharge") {
        let d = data;
        d.appid = localStorage.getItem("appid");
        this.doBalanceRecharge(50, d);
      }
    },

    /**  钱包余额支付  **/
    doRechargeByBalance(data) {
      // 流量套餐充值
      if (this.showCheckstandSource == "flowRecharge") {
        // this.price = data.salePriceRmb;
        // console.log(data)
        for (let key in data) {
          this.payData[key] = data[key];
        }
        let d = this.payData;
        d.payType = 40;
        wxRequest("order/user/uniorder", d, "post").then((res) => {
          if (res.data.code == 200) {
            this.yuePayParam.orderNo = res.data.data.id;
            this.yuePayParam.iccid = localStorage.getItem("iccid");
            this.yuePayParam.mobile = localStorage.getItem("mobile");

            //唤起密码输入框
            this.showPasswordPanel = true;
          } else if (res.data.code == 402) {
            let self = this;

            Dialog.confirm({
              title: "提示",
              message: res.data.message + ", 请点击【确认】前往开户",
            })
              .then(() => {
                if (this.yucun == 1 || this.yucun == 888) {
                  self.$router.push({
                    path: "/user/huodong",
                    query: {
                      iccid: self.$store.state.iccid,
                    },
                  });
                } else {
                  self.$router.push({
                    path: "/user/balanceRecharge",
                    query: {
                      iccid: self.$store.state.iccid,
                    },
                  });
                }
              })
              .catch(() => { });
          } else {
            this.$messagebox.alert(res.data.message);
            this.cancelPay();
          }
        });
      }
    },

    /**  汇付天下  AdaPay  **/
    flowRechargeByAdaPay(data) {
      // 流量套餐充值
      if (this.showCheckstandSource == "flowRecharge") {
        this.cancelPay();
        for (let key in data) {
          this.payData[key] = data[key];
        }
        let d = this.payData;

        let formData = new FormData();
        Object.keys(d).forEach((key) => {
          formData.append(key, d[key]);
        });

        wxRequest("order/hfPkgOrder/add", formData, "post").then((res) => {
          if (res.data.code == 200) {
            let data = JSON.parse(res.data.data);
            if (data.status === "succeeded") {
              let payment = data;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: "提示", message: res.result_message });
                this.cancelPay();
              });
            }
          } else if (res.data.code == 888) {
            Dialog.confirm({
              title: "购买成功",
              message: "购买成功！实名后方能正常使用（已实名请忽略）",
            })
              .then((action) => {
                if (action == "confirm") {
                  this.toHome();
                }
              })
              .catch(() => {

              });
          } else {
            Dialog.alert({ title: "提示", message: res.data.message });
            this.cancelPay();
          }
        });

        // 余额套餐充值
      } else if (this.showCheckstandSource == "balanceRecharge") {
        let d = data;
        d.appid = localStorage.getItem("appid");
        this.doBalanceRecharge(60, d);
      }
    },

    /** 账户余额充值时， 通过type选择支付方式 **/
    doBalanceRecharge(type, data) {
      let d = this.payData;
      for (let key in data) {
        d[key] = data[key];
      }
      d.payType = type ? type : null;

      wxRequest("order/user/create/investOrder", d, "post").then((res) => {
        if (res.data.code == 200) {
          if (type == 20) {
            var param = res.data.data.param;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (type == 32) {
            var param = res.data.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (type == 30) {
            let div = document.createElement("div");
            div.innerHTML = res.data.data;

            let jdPayFormDiv = document.getElementById("jdPayFormDiv");
            jdPayFormDiv.appendChild(div);
            let form = document.getElementById("batchForm");
            console.log(form);
            form.submit();

            let childs = jdPayFormDiv.childNodes;
            for (let i = childs.length - 1; i >= 0; i--) {
              jdPayFormDiv.removeChild(childs[i]);
            }
          } else if (type == 50) {
            //乐刷支付
            window.location.href = res.data.data.jspay_url;
          } else if (type == 60) {
            //汇付天下

            let data = JSON.parse(res.data.data);
            if (data.status === "succeeded") {
              let payment = data;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: "提示", message: res.result_message });
                this.cancelPay();
              });
            }
          } else if (type == 80) {
            window.location.href = res.data.data;
            // var ua = window.navigator.userAgent.toLowerCase();
            // if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            //   //进入引导页
            //   this.is_WeChat = true
            //   var timer = setInterval(() => {
            //     clearInterval(timer)
            //     this.$router.push({ path: this.$route.path, query: { row: encodeURIComponent(JSON.stringify(res.data.data)) } });
            //   }, 1000)
            // } else {
            //   this.payUrl = res.data.data
            //   this.$nextTick(() => {
            //     document.forms[0].submit()
            //   })
            // }
          }
        } else {
          this.$messagebox.alert(res.data.message);
          this.cancelPay();
        }
      });
    },
    toHome() {
      let _this = this;
      if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
        _this.$router
          .push({
            path: "/user/homeNew",
            query: {
              iccid: _this.$store.state.iccid,
            },
          })
          .catch(() => { });
      } else if (_this.$store.state.isNewPage == 2 || localStorage.getItem('isNewPage') == 2) {
        _this.$router
          .push({
            path: "/user/homeTwo",
            query: {
              iccid: _this.$store.state.iccid,
            },
          })
          .catch(() => { });
      } else if (_this.$store.state.isNewPage == 6 || localStorage.getItem('isNewPage') == 6) {
        _this.$router
          .push({
            path: "/userNew/home",
            query: {
              iccid: _this.$store.state.iccid,
            },
          })
          .catch(() => { });
      } else {
        _this.$router
          .push({
            path: "/user/home",
            query: {
              iccid: _this.$store.state.iccid,
            },
          })
          .catch(() => { });
      }
    },
    //流量套餐充值时唤起微信支付
    onBridgeReady(param) {
      let _this = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          if (_this.$store.state.isNewPage == 1 || localStorage.getItem('isNewPage') == 1) {
            _this.$router
              .push({
                path: "/user/homeNew",
                query: {
                  iccid: _this.$store.state.iccid,
                },
              })
              .catch(() => { });
          } else if (_this.$store.state.isNewPage == 2 || localStorage.getItem('isNewPage') == 2) {
            _this.$router
              .push({
                path: "/user/homeTwo",
                query: {
                  iccid: _this.$store.state.iccid,
                },
              })
              .catch(() => { });
          } else if (_this.$store.state.isNewPage == 6 || localStorage.getItem('isNewPage') == 6) {
            _this.$router
              .push({
                path: "/userNew/home",
                query: {
                  iccid: _this.$store.state.iccid,
                },
              })
              .catch(() => { });
          } else {
            _this.$router
              .push({
                path: "/user/home",
                query: {
                  iccid: _this.$store.state.iccid,
                },
              })
              .catch(() => { });
          }
        }
      });
    },

    cancelPay() {
      this.$store.state.showCheckstand = false;
    },

    cancelInputPassword() {
      this.yuePayParam.payPass = "";
      this.showPasswordPanel = false;
    },

    showPayChannel(payType) {
      return this.payTypeList.includes(payType);
    },
  },

  created() {
    this.is_WeChat = false
    if (this.$route.query.row) {
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
      this.$nextTick(() => {
        document.forms[0].submit()
      })
    }
    this.$store.state.showCheckstand = false;
    this.payData.iccid = localStorage.getItem("iccid");
    this.payData.mobile = localStorage.getItem("mobile");
    this.payData.source = this.$store.state.source
      ? this.$store.state.source
      : "";

    let data = { iccid: localStorage.getItem("iccid") };
    this.$nextTick(() => {
      //props获取不到，需要nextTick
      wxRequest("/order/pay/chanle", data, "post").then((res) => {
        console.log(1, this.typeStyle);
        if (res.data.code == 200) {
          for (let i = 0; i < res.data.data.length; i++) {
            this.payTypeList.push(res.data.data[i].typeKey);
          }
        } else if (res.data.code == 205) {
          if (this.typeStyle == 1) {
            this.payTypeList.push("yeCollectConfig");
          } else {
            for (let i = 0; i < res.data.data.length; i++) {
              this.payTypeList.push(res.data.data[i].typeKey);
            }
          }
        }
      });
    });
  },

  computed: {
    showCheckstand: function () {
      return this.$store.state.showCheckstand;
    },

    showCheckstandSource: function () {
      return this.$store.state.showCheckstandSource;
    },
  },

  watch: {},
};
</script>

<style>
.checkstand-defined .cancelPay .van-button--round {
  float: right;
}

.checkstand-defined .cancelInput .van-icon {
  margin: 10px 15px 10px 0;
  position: absolute;
  right: 0;
}

.checkstand-defined .passwordPanel .van-field__label {
  width: 60px;
}

.checkstand-defined .cancelInput .van-icon-close:before {
  font-size: 20px;
}

.checkstand-defined .van-icon::before {
  line-height: 30px;
}

.checkstand-defined .wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.checkstand-defined .block {
  width: 120px;
  height: 120px;
  background-color: #fff;
}

.checkstand-defined .passwordPanel .van-field__control {
  line-height: 24px;
}

.checkstand-defined .van-icon,
.checkstand-defined .van-icon::before {
  line-height: 62px;
}

.checkstand-defined .van-divider {
  padding: 0;
  margin: 0;
}
</style>

<style lang="less">
.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}

.checkstand-defined {
  .hide {
    height: 0;
  }

  .order-info {
    display: flex;
    padding: 20px 30px 0 30px;

    .order-price {
      flex: 1;
      color: red;
      text-align: right;
      font-size: 18px;
    }
  }

  .payTypeList {
    padding: 10px 30px;

    .payTypeList-item {
      height: 62px;
      line-height: 62px;
      display: flex;

      .payTypeList-item-img {
        display: flex;
        flex: 1;
        justify-content: center;

        img {
          align-self: center;
          width: 30px;
          height: 30px;
        }
      }

      .payTypeList-item-name {
        flex: 4;
        display: flex;
        align-content: center;
        font-size: 16px;
        font-weight: blod;

        .jd-item {
          height: 40px;
          align-self: center;

          p {
            height: 20px;
            line-height: 20px;
            margin: 0;
            padding: 0;
          }
        }
      }

      .payTypeList-item-icon {
        display: flex;
        justify-content: center;
        width: 30px;
        height: 62px;
        flex: 0;

        >div {
          flex: 0;
          align-content: center;
          float: right;
        }
      }
    }

    .payTypeList-item:first-child {
      .payTypeList-item-name {
        display: flex;
        align-self: center;
        height: 60px;
      }
    }
  }

  .passwordPanel {
    p {
      text-align: center;
      color: "#323233";
      margin-bottom: 30px;
    }

    h1 {
      font-size: 28px;
      text-align: center;
      color: "#323233";
      margin-bottom: 30px;

      span {
        font-size: 20px;
      }
    }

    .van-cell-group {
      padding: 10px 5px;
    }
  }

  .cancelInput {
    height: 20px;
  }

  .cancelPay {
    padding: 0 30px 50px 30px;

    >div {
      float: right;
    }
  }
}
</style>
